import { useContext, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { APP_NAME } from '../../config';
import { UserContext } from '../../context';
import { useDocumentTitle, useSessionStorage } from '../../hooks';
import { formatErrorMessage } from '../../utils';

const useNavBar = ({ menuItems = [], updateMerchant }) => {
  const [currentDropdown, setCurrentDropdown] = useState('');
  const [openMenu, setOpenMenu] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [isLive, setisLive] = useState(user?.isLive ?? false);
  const [merchant, setMerchant] = useSessionStorage(APP_NAME, '');
  const [disableSwitch, setDisableSwitch] = useState(false);

  const MENU_ITEMS = menuItems;

  let { pathname } = useLocation();

  user.isLive = user?.isLive === undefined ? false : user?.isLive;
  let currentPath = MENU_ITEMS.find(({ path, hasSubRoutes, tabs }) => {
    if (hasSubRoutes || tabs) {
      return pathname.includes(path);
    } else {
      return matchPath(pathname, {
        path,
        exact: true,
        strict: false
      });
    }
  });

  let {
    pageTitle = { normal: '', cursive: '' },
    tabs,
    path: tabBaseUrl,
    breadcrumb,
    cta
  } = currentPath ?? {};

  useDocumentTitle(currentPath && currentPath.name);

  const handleLiveChange = async () => {
    const newLiveState = !isLive;
    const { merchantUser, token } = merchant;
    const { merchantId } = merchantUser;

    // Read isKycVerified from context (kept in sync by useFetchMerchantProfile)
    // rather than from sessionStorage which may be stale
    if (newLiveState === true && !user?.isKycVerified) {
      toast.error(
        'You cannot switch to Live Mode. Please complete and get your KYC approved first.'
      );
      return;
    }

    setDisableSwitch(true);

    try {
      await updateMerchant({
        merchantId,
        is_live: newLiveState
      });

      setDisableSwitch(false);
      setisLive(newLiveState);
      toast.success(`Successfully switched to ${!isLive ? 'Live' : 'Test'} Mode`);

      merchantUser.isLive = newLiveState;

      const updatedMerchant = {
        ...merchant,
        token,
        merchantUser
      };
      setUser(merchantUser);
      setMerchant(updatedMerchant);

      setTimeout(() => {
        location.reload();
      }, 1500);
    } catch (error) {
      setDisableSwitch(false);
      formatErrorMessage(error);
    }
  };

  const toggleDropdown = (dropdown) => {
    setCurrentDropdown(dropdown);
  };

  const closeDropdown = () => {
    setCurrentDropdown('');
  };

  return {
    user,
    openMenu,
    setOpenMenu,
    isLive,
    currentDropdown,
    disableSwitch: disableSwitch,
    tabs,
    tabBaseUrl,
    pageTitle,
    handleLiveChange,
    toggleDropdown,
    closeDropdown,
    breadcrumb,
    cta
  };
};

export { useNavBar };
